import axios from "axios";
import Base64 from "js-base64";
import { Loading, Message } from "element-ui";
import RequestPath from "../utils/RequestPath";
import utils from "./utils";
import Global from "../utils/Global";
import router from "../router";
import { RefreshToken, apiUserPhoneSms } from "./service/user";
import Cookies from "js-cookie";
import Qs from "qs";
import {getOS} from "../utils/MobileGlobal";

const PATH = RequestPath.PATH,
  axiosInfo = {
    loading: null,
    services: "",
    token: {}
  };
// 超时时间
axios.defaults.timeout = 1000000;
axios.defaults.withCredentials = true;

const resultValid = (data, service) => {
  switch (data.respCode) {
    case -201:
    case -202:
      if(getOS() === "PC") {
         Global.messageErr("服务器拥堵，请稍后再试");
      }
      break;
    case -888:
      router.replace({
        path: "/"
      });
      break;
    case -999:
      if(getOS() === "PC") {
        Global.messageErr("没有该操作权限,请联系客服");
      }
      break;
    default:
      return utils.next(service, data);
  }
};
/**
 * 处理loading
 * @param {*} loadingFlag
 */
const processLoading = loadingFlag => {
  if (loadingFlag) {
    axiosInfo.loading = Loading.service({
      text: "加载中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.8)",
      customClass: "tr-loading"
    });
  }
};
/**
 * 处理loading
 */
const loadingClose = () => {
  if (axiosInfo.loading) {
    axiosInfo.loading.close();
  }
};
/**
 * 处理url
 * @param {*} service
 * @param {*} url
 */
const processURL = (service, url, item = "2/", transURL = true) => {
  url = transURL ? Base64.Base64.encode(url) : url;
  axiosInfo.services = service;
  url = `${PATH[axiosInfo.services] || ""}${item}${url}`;
  return url;
};
/**
 * 处理token
 * @param {*} data
 */
// const processToken = data =>
//   Object.assign(common.deepCopy(axiosInfo.token), data || {});

/**
 * 封装axios的get请求
 * @param {*} requestData
 */
function get(requestData) {
  return new Promise((resolve, reject) => {
    if(getOS() === "PC") {
      processLoading(requestData.loading);
    }
    axios({
      method: "get",
      url: processURL(
        requestData.service,
        requestData.url,
        requestData.urlItem,
        requestData.transURL
      ),
      params: requestData.token,
      headers: requestData.headers || {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
      }
    })
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        loadingClose();
        // Global.messageErr("网络异常");
        if(getOS() === "PC") {
          Message.error("网络异常，请稍后再试");
        }
        reject(error);
      });
  });
}

/**
 * 封装axios的post请求
 * @param {*} requestData
 */
function post(requestData) {
  return new Promise((resolve, reject) => {
    if(getOS() === "PC") {
      processLoading(requestData.loading);
    }
    axios({
      method: "post",
      url: processURL(
        requestData.service,
        requestData.url,
        requestData.urlItem,
        requestData.transURL
      ),
      data: requestData.data,
      headers: requestData.headers || {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        authentication: false
      }
    })
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        loadingClose();
        // Global.messageErr("网络异常");
        if(getOS() === "PC") {
          Message.error("网络异常，请稍后再试");
        }
        reject(error);
      });
  });
}

function all(methods) {
  return new Promise((resolve, reject) => {
    axios
      .all(methods)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        if(getOS() === "PC") {
          Message.error("网络异常，请稍后再试");
        }
        reject(error);
      });
  });
}

/**
 * 请求拦截器
 */
axios.interceptors.request.use(
  config => utils.requestInterceptors(config),
  error => Promise.reject(error)
);
/**
 * 响应拦截器
 */
axios.interceptors.response.use(
  async response => {
    loadingClose();
    if (response.status === 200) {
      let message = resultValid(response.data, axiosInfo.services);
      // c2NlbmljL2dldFRyYXZlbE5vdGVJbmZvRGV0YWls
      // if(response.config.url.indexOf("c2NlbmljL2dldFRyYXZlbE5vdGVJbmZvRGV0YWls")!==-1){
      //   if(flag){
      //     response.data.respCode = -128;
      //     flag = false;
      //   }
      // }
      if (message !== "" && message !== undefined) {
        if(getOS() === "PC") {
           Message.error(message);
        }
      }
      if(response.data.respCode === -128) {
      //如果token失效
        RequestPath.webRefreshToken(
          Cookies.get("userInfo_productId"),
          Cookies.get("userInfo_appId"),
          Cookies.get("userInfo_userId"),
          Cookies.get("userInfo_token"),
          Cookies.get("userInfo_refreshToken")
        );
        let res = await refreshToken({
          webOemId: Cookies.get("userInfo_productId"),
          webAppId: Cookies.get("userInfo_appId"),
          webUserId: Cookies.get("userInfo_userId"),
          webUserToken: Cookies.get("userInfo_token"),
          webRefreshToken: Cookies.get("userInfo_refreshToken")
        });
        
        Cookies.set("userInfo_refreshToken", res.refreshToken, 7);
        Cookies.set("userInfo_token", res.token, 7);
        RequestPath.webServiceInterface(
          Cookies.get("userInfo_productId"),
          Cookies.get("userInfo_appId"),
          Cookies.get("userInfo_userId"),
          res.token
        );
        RequestPath.userInformatin(
          Cookies.get("userInfo_productId"),
          Cookies.get("userInfo_appId"),
          Cookies.get("userInfo_userId"),
          res.token
        );
        let array1 =  response.config.url.split("api/");
        let array2 = array1[1].split('/')
        array2.splice(3,1,res.token)
        let Str = array2.join("/");
        let newUrl = `${array1[0]}api/${Str}`
        return await axios({
          method: response.config.method,
          url: newUrl,
          data: Qs.parse(response.config.data), //参数需要使用qs转换否则后台报错"缺失参数"
          headers: response.config.headers
        });
      }
      //如果用户被踢出
      else if (response.data.respCode === -134) {
        router.push({
          name: "login"
        });
      }
      return response;
    } else {
      Global.messageErr("网络异常,请稍后再试");
    }
  },
  error => Promise.reject(error)
);

const refreshToken = params => {
  RequestPath.webRefreshToken(
    Cookies.get("userInfo_productId"),
    Cookies.get("userInfo_appId"),
    Cookies.get("userInfo_userId"),
    Cookies.get("userInfo_token"),
    Cookies.get("userInfo_refreshToken")
  );
  return RefreshToken({
    webOemId: Cookies.get("userInfo_productId"),
    webAppId: Cookies.get("userInfo_appId"),
    webUserId: Cookies.get("userInfo_userId"),
    webUserToken: Cookies.get("userInfo_token"),
    webRefreshToken: Cookies.get("userInfo_refreshToken")
  }).then(res => res.data)
}

/**
 * 设置token信息
 * @param {*} data
 */
const setToken = data => {
  axiosInfo.token = data;
};

export default {
  mockdata(requestData) {
    return requestData.method === "post" ? post(requestData) : get(requestData);
  },
  get(requestData) {
    return get(requestData);
  },
  post(requestData) {
    return post(requestData);
  },
  all(methods) {
    return all(methods);
  },
  spread(methods) {
    return axios.spread(methods);
  },
  PATH,
  setToken
};
